/**
 * TanStack Query keys for blog feature
 */
export const blogKeys = {
  all: ["blogs"] as const,
  lists: () => [...blogKeys.all, "list"] as const,
  list: (locale: string, page?: number, sort?: any) =>
    [...blogKeys.lists(), locale, page, sort] as const,
  details: () => [...blogKeys.all, "detail"] as const,
  detail: (id: number, locale: string) => [...blogKeys.details(), id, locale] as const,
};
